export const transferDbDate = dbDate => {
  if (!dbDate) return ''
  const date = dbDate.split('T')[0]
  const [y, m, d] = date.split('-')
  return m + '/' + d + '/' + y
}

export const getYearsPrependOptions = (prefix, suffix = '-') => {
  const date = new Date()
  const thisYear = date.getFullYear()
  const startYear = 2022
  const res = []
  for (let year = startYear; year <= thisYear; year++) {
    const yearPrepend = prefix + '-' + year.toString().slice(2, 4) + suffix
    res.push({ label: yearPrepend, value: yearPrepend })
  }
  return res.reverse()
}
